import { INTEGRATIONS_ACTIONS, initialIntegrationsState } from './integrations.types'

/**
 *
 * @param {import('./integrations.types').IntegrationsSlice} state
 * @param {import('./integrations.types'.IntegrationsAction)} action
 * @returns
 */
export function integrationsReducer(state = initialIntegrationsState, { type, payload }) {
  switch (type) {
    case INTEGRATIONS_ACTIONS.SET_FEATUREBASE_STATUS:
      return {
        ...state,
        featurebase: { ...state.featurebase, status: payload }
      }

    case INTEGRATIONS_ACTIONS.SET_FEATUREBASE_ERRORS:
      return {
        ...state,
        featurebase: { ...state.featurebase, errors: payload }
      }

    case INTEGRATIONS_ACTIONS.SET_FEATUREBASE_TASK:
      return {
        ...state,
        featurebase: { ...state.featurebase, tast: payload }
      }

    case INTEGRATIONS_ACTIONS.SET_FEATUREBASE_CHANGELOG:
      return {
        ...state,
        featurebase: { changelog: { ...state.featurebase.changelog, ...payload } }
      }

    default:
      return state
  }
}
